export default {
    'Menu': 'Menu'
};
